import { useEffect } from 'react';

import inlineBannerStyles from '#components/ui/layout/InlineUnauthenticatedBanner.module.css';
import { trackSignUp } from '#utils/loginUtils';

import { StatsigMigrationOfferClaimModal } from './StatsigMigrationOfferClaimModal';

export const StatsigMigrationOfferBanner = () => {
  useEffect(() => {
    trackSignUp('Statsig Migration Offer Banner Viewed', {
      component: 'StatsigMigrationOfferBanner',
      url: window.location.pathname,
    });
  }, []);

  const handleClaimLinkClick = () => {
    trackSignUp('Statsig Migration Offer Claim Link Clicked', {
      component: 'StatsigMigrationOfferBanner',
      url: window.location.pathname,
    });
  };

  return (
    <div className={inlineBannerStyles.banner}>
      <p className={inlineBannerStyles.heading}>Switching from Statsig?</p>
      <div className={inlineBannerStyles.description}>
        Use LaunchDarkly for free until your Statsig renewal date, up to 1 year. Migration tool included.{' '}
        <StatsigMigrationOfferClaimModal onClaimLinkClick={handleClaimLinkClick} />
      </div>
    </div>
  );
};
